import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderThree from "../components/HeaderThree";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import Newsletter from "../components/Newsletter";
import ContactInner from "../components/ContactInner";



const Contact = () => {
  let [active, setActive] = useState(true);
  useEffect(() => {
    setTimeout(function () {
      setActive(false);
    }, 500);
  }, []);
  return (
    <>
      {active === true && <Preloader />}

      <HelmetReact title={"Contact"} />

      <HeaderThree />

      <Breadcrumb title="Contact" />

      {/* ContactInner */}
      <ContactInner />

      {/* FooterOne */}
      <FooterOne />

    </>
  );
};

export default Contact;
